/**
 * Phone-support code widget: on/off.
 *
 * Two switches, checked in this order:
 *
 *   1. `localStorage.lh_phone_support` — per-browser override. Lets you turn
 *      the widget on for yourself in production (or off, if it misbehaves)
 *      without a redeploy. Set to "true" or "false".
 *   2. `VITE_PHONE_SUPPORT=true` — the build-time default for everyone else.
 *
 * Same shape as `isSDATestMode`, plus the override because this one is meant
 * to be rolled out gradually rather than only used in development.
 *
 * To enable for yourself in any environment, run in the browser console:
 *   localStorage.setItem("lh_phone_support", "true")
 * and to go back to the deployed default:
 *   localStorage.removeItem("lh_phone_support")
 */
export const PHONE_SUPPORT_OVERRIDE_KEY = "lh_phone_support";

export const isPhoneSupportEnabled = (): boolean => {
  // localStorage throws in some privacy modes; a flag check must never be
  // the thing that breaks a page.
  try {
    const override = window.localStorage.getItem(PHONE_SUPPORT_OVERRIDE_KEY);
    if (override === "true") return true;
    if (override === "false") return false;
  } catch {
    /* fall through to the build-time default */
  }
  return import.meta.env.VITE_PHONE_SUPPORT === "true";
};

/** The number callers dial. Shown next to the code so it's one action. */
export const PHONE_SUPPORT_NUMBER =
  import.meta.env.VITE_SUPPORT_PHONE || "(805) 272-0003";
